import React from 'react';
import { Chip, ChipProps } from '@mui/material';
import { formatStatusLabel } from '../../utils/matchDisplay';

interface StatusChipProps extends Omit<ChipProps, 'label' | 'color'> {
  status: string;
  label?: string;
}

export const StatusChip: React.FC<StatusChipProps> = ({
  status,
  label,
  ...props
}) => {
  const getStatusColor = (status: string): ChipProps['color'] => {
    const normalizedStatus = status.toLowerCase();
    
    if (normalizedStatus.includes('active') || normalizedStatus.includes('approved') || normalizedStatus.includes('confirmed') || normalizedStatus === 'open') {
      return 'success';
    }
    if (normalizedStatus.includes('pending') || normalizedStatus.includes('waiting')) {
      return 'warning';
    }
    if (normalizedStatus.includes('inactive') || normalizedStatus.includes('rejected') || normalizedStatus.includes('cancelled')) {
      return 'error';
    }
    if (normalizedStatus.includes('completed') || normalizedStatus.includes('finished')) {
      return 'info';
    }
    
    return 'default';
  };

  return (
    <Chip
      label={label || formatStatusLabel(status)}
      color={getStatusColor(status)}
      size="small"
      {...props}
    />
  );
};

